import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Select } from 'antd';
import { Card } from '@cards/Card';
import useWizard from '@components/Wizard/useWizard';
import { useFeature } from '@hooks';

function Content() {
  const { t } = useTranslation();
  const { currentStepData, form } = useWizard();
  const { getFieldsValue } = form;
  const { externalVideoProviders } = useFeature('externalVideoProviders');

  const validateURL = (rule, value, callback) => {
    const { videoType } = getFieldsValue();

    if (!value || value.trim() === '') {
      callback();
      return;
    }

    if (
      videoType === 'youtube' &&
      !value.startsWith('https://www.youtube.com/') &&
      !value.startsWith('https://youtube.com/') &&
      !value.startsWith('https://youtu.be/')
    ) {
      callback(t('common:Wizard.details.link.invalidYouTubeURL'));
      return;
    }
    if (
      videoType === 'movingimage' &&
      (!value.startsWith('https://') || value.indexOf('video-cdn.net') === -1)
    ) {
      callback(t('common:Wizard.details.link.invalidMovingImageURL'));
      return;
    }

    callback();
  };

  const handleVideoTypeChange = () => {
    // Does not work without setTimeout
    setTimeout(() => {
      form.validateFields(['link']);
    }, 0);
  };

  return (
    <Card.Half>
      <Form labelCol={{ span: 8 }} layout="vertical" wrapperCol={{ span: 16 }}>
        <fieldset>
          <legend>{t('common:Wizard.details.video')}</legend>
          <Form.Item label={t('common:Wizard.details.title.videoLabel')}>
            {form.getFieldDecorator('title', {
              rules: [
                {
                  required: true,
                  message: t('common:Wizard.details.title.required'),
                },
              ],
              initialValue: currentStepData.title || '',
            })(<Input placeholder="Title on page" />)}
          </Form.Item>
          <Form.Item label={t('common:Wizard.details.description.label')}>
            {form.getFieldDecorator('videoDescription', {
              initialValue: currentStepData.videoDescription || '',
            })(
              <Input.TextArea
                autoSize
                placeholder={t('common:Wizard.details.description.placeholder')}
              />,
            )}
          </Form.Item>
          <Form.Item label={t(`common:Wizard.details.videoType.label`)}>
            {form.getFieldDecorator('videoType', {
              initialValue: currentStepData.videoType || 'youtube',
              rules: [
                {
                  required: true,
                  message: t(`common:Wizard.details.videoType.required`),
                },
              ],
            })(
              <Select onChange={handleVideoTypeChange}>
                <Select.Option value="youtube">
                  {t(`common:Wizard.details.videoType.youtube`)}
                </Select.Option>
                {externalVideoProviders && externalVideoProviders.includes('movingimage') && (
                  <Select.Option value="movingimage">
                    {t(`common:Wizard.details.videoType.movingimage`)}
                  </Select.Option>
                )}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label={t('common:Wizard.details.link.label')}>
            {form.getFieldDecorator('link', {
              rules: [
                {
                  required: true,
                  message: t('common:Wizard.details.link.required'),
                },
                {
                  validator: validateURL,
                },
              ],
              initialValue: currentStepData.link || '',
            })(<Input placeholder={t('common:Wizard.details.link.placeholder')} />)}
          </Form.Item>
          <Form.Item label={t('videos:Wizard.details.publishDate')}>
            {form.getFieldDecorator('publishDate', {
              rules: [],
              initialValue: currentStepData.publishDate || '',
            })(<Input placeholder={t('videos:Wizard.details.optional')} />)}
          </Form.Item>
          <Form.Item label={t('videos:Wizard.details.runTime')}>
            {form.getFieldDecorator('runTime', {
              rules: [],
              initialValue: currentStepData.runTime || '',
            })(<Input placeholder={t('videos:Wizard.details.optional')} />)}
          </Form.Item>
        </fieldset>
      </Form>
    </Card.Half>
  );
}

export default Content;
